/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function FilterBlurSmall(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'FilterBlurSmall',
      'aria-hidden': true,
      focusable: false,
      width:  12 * scale,
      height: 12 * scale,
      viewBox: '0 0 12 12',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('rect', {"width":"3","height":"3","rx":"1.5","transform":"translate(1)","fill":"currentColor"}),createElement('path', {"d":"M5.5 1.5a1 1 0 112 0 1 1 0 01-2 0zm3.5 0a.5.5 0 111 0 .5.5 0 01-1 0z","fill":"currentColor"}),createElement('rect', {"width":"3","height":"3","rx":"1.5","transform":"translate(1 4)","fill":"currentColor"}),createElement('path', {"d":"M5.5 5.5a1 1 0 112 0 1 1 0 01-2 0zm3.5 0a.5.5 0 111 0 .5.5 0 01-1 0z","fill":"currentColor"}),createElement('rect', {"width":"3","height":"3","rx":"1.5","transform":"translate(1 8)","fill":"currentColor"}),createElement('path', {"d":"M5.5 9.5a1 1 0 112 0 1 1 0 01-2 0zm3.5 0a.5.5 0 111 0 .5.5 0 01-1 0z","fill":"currentColor"}))
}
